module.exports = __webpack_public_path__ + "media/CN_001.41649aa8.mp3";